import { createSelector } from 'reselect';
import { selectRouteQuery } from 'selectors/general';

export const selectColumnFocus = createSelector(selectRouteQuery, ({ focus }) => focus);
